/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyPUESCSentDocumentSerializer,
    ReadOnlyPUESCSentDocumentSerializerFromJSON,
    ReadOnlyPUESCSentDocumentSerializerFromJSONTyped,
    ReadOnlyPUESCSentDocumentSerializerToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20040
 */
export interface InlineResponse20040 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20040
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20040
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20040
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyPUESCSentDocumentSerializer>}
     * @memberof InlineResponse20040
     */
    results: Array<ReadOnlyPUESCSentDocumentSerializer>;
}

export function InlineResponse20040FromJSON(json: any): InlineResponse20040 {
    return InlineResponse20040FromJSONTyped(json, false);
}

export function InlineResponse20040FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20040 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyPUESCSentDocumentSerializerFromJSON)),
    };
}

export function InlineResponse20040ToJSON(value?: InlineResponse20040 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyPUESCSentDocumentSerializerToJSON)),
    };
}


